
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchDiningTables, addDiningTable, deleteDiningTable, updateSortIndex } from './diningTableApi';

export interface DiningTable {
  id: string;
  name: string;
  sortIndex: number;
}

interface DiningTableState {
  tables: DiningTable[];
  loading: boolean;
  error: string | null;
}

const initialState: DiningTableState = {
  tables: [],
  loading: false,
  error: null,
};

const diningTableSlice = createSlice({
  name: 'diningTable',
  initialState,
  reducers: {
    updateLocalOrder(state, action: PayloadAction<DiningTable[]>) {
      state.tables = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDiningTables.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDiningTables.fulfilled, (state, action: PayloadAction<DiningTable[]>) => {
        state.tables = action.payload;
        state.loading = false;
      })
      .addCase(fetchDiningTables.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addDiningTable.fulfilled, (state, action: PayloadAction<DiningTable>) => {
        state.tables.push(action.payload);
      })
      .addCase(deleteDiningTable.fulfilled, (state, action: PayloadAction<string>) => {
        state.tables = state.tables.filter((table) => table.id !== action.payload);
      })
      .addCase(updateSortIndex.fulfilled, (state) => {
        // ローカルの状態はサーバーからのデータ取得後に更新
      });
  },
});

export const { updateLocalOrder } = diningTableSlice.actions;
export default diningTableSlice.reducer;